import * as widgets from "../../extractedComponents/index";
import * as icons from "../../components/ReportLayoutManager/components/assets/index";

type IconType = keyof typeof icons;
type IdType = keyof typeof widgets;
interface IReportSectionItem {
  icon: IconType;
  id: IdType;
  text: string;
}
interface IReportLayoutSection {
  id: string;
  title: string;
  items: IReportSectionItem[];
}

export const ReportLayoutSections: IReportLayoutSection[] = [
  {
    id: "widgets",
    title: "Widgets",
    items: [{ icon: "Table", id: "TextEditorWidget", text: "Text Editor" }],
  },
  {
    id: "executive",
    title: "Summary",
    items: [
      {
        icon: "Table",
        id: "ExecutiveReportWidget",
        text: "Executive Summary",
      },
      {
        icon: "Table",
        id: "OverviewTableWidget",
        text: "Overview Table",
      },
    ],
  },
  {
    id: "performance",
    title: "Performance",
    items: [
      {
        icon: "LineChart",
        id: "PerformanceVsBenchmarkWidget",
        text: "Performance vs Benchmark",
      },
      {
        icon: "LineChart",
        id: "PerformanceByAllocationWidget",
        text: "Performance by Allocation",
      },
    ],
  },
  {
    id: "netWorth",
    title: "Net Worth",
    items: [
      {
        icon: "PieChart",
        id: "NetWorthPieWidget",
        text: "Net worth pie",
      },
      {
        icon: "LineChart",
        id: "NetWorthBreakdownWidget",
        text: "Net worth breakdown",
      },
    ],
  },
  {
    id: "pnl",
    title: "P&L",
    items: [
      {
        icon: "LineChart",
        id: "PnLByAssetClassWidget",
        text: "P&l by asset class",
      },
      {
        icon: "LineChart",
        id: "NetWorthVsInvestmentWidget",
        text: "Net worth vs investment",
      },
      {
        icon: "BarChart",
        id: "PositionsByAbsolutePnlWidget",
        text: "Positions absolute P&L",
      },
    ],
  },
  {
    id: "pnlMonthly",
    title: "P&L Monthly",
    items: [
      {
        icon: "LineChart",
        id: "MonthlyPnl",
        text: "Monthly P&L",
      },
      {
        icon: "LineChart",
        id: "PnlByAttribution",
        text: "P&L by attribution",
      },
    ],
  },

  {
    id: "riskDaily",
    title: "Risk Daily",
    items: [
      {
        icon: "LineChart",
        id: "DailyDrawdownWidget",
        text: "Risk Drawdown",
      },
      {
        icon: "Gauge",
        id: "RiskGaugeDailyWidget",
        text: "Risk Gauge",
      },
      {
        icon: "Table",
        id: "RiskDailyTableWidget",
        text: "Risk Table",
      },
      {
        icon: "LineChart",
        id: "DailyReturnsWidget",
        text: "Daily Returns",
      },
      {
        icon: "LineChart",
        id: "DailyMarketValueVsExposureWidget",
        text: "Market Value vs Exposure",
      },
      {
        icon: "LineChart",
        id: "DailyLeverageRatioWidget",
        text: "Leverage Ratio",
      },
    ],
  },

  {
    id: "riskMonthly",
    title: "Risk Monthly",
    items: [
      {
        icon: "LineChart",
        id: "MonthlyDrawDown",
        text: "Monthly Drawdown",
      },
      {
        icon: "Gauge",
        id: "RiskGaugeMonthlyWidget",
        text: "Risk Gauge (Monthly)",
      },
      {
        icon: "Table",
        id: "RiskMonthlyTableWidget",
        text: "Risk Table (Monthly)",
      },
      {
        icon: "LineChart",
        id: "MonthlyReturnsWidget",
        text: "Monthly Returns",
      },
      {
        icon: "LineChart",
        id: "MonthlyMarketValueVsExposureWidget",
        text: "Market Value vs Exposure",
      },
      {
        icon: "LineChart",
        id: "MonthlyLeverageRatioWidget",
        text: "Leverage Ratio",
      },
    ],
  },
  {
    id: "riskReturn",
    title: "Risk Return",
    items: [
      {
        icon: "Scatter",
        id: "RiskReturnScatterWidget",
        text: "Risk Return Scatter",
      },
      {
        icon: "Table",
        id: "RiskReturnTableWidget",
        text: "Risk Return Table",
      },
    ],
  },
  {
    id: "income",
    title: "Income",
    items: [
      {
        icon: "BarChart",
        id: "IncomeByAssetClassWidget",
        text: "Income by asset class",
      },
      {
        icon: "BarChart",
        id: "ProjectedFutureIncomeWidget",
        text: "Projected future income",
      },
    ],
  },
  {
    id: "scenarios",
    title: "Scenarios",
    items: [
      {
        icon: "BarChart",
        id: "ScenarioManagerWidget",
        text: "Scenario Manager",
      },
    ],
  },
  {
    id: "Transactions",
    title: "Transactions",
    items: [
      { icon: "Table", id: "TransactionsWidget", text: "Transactions" },
      { icon: "Table", id: "PositionsWidget", text: "Positions" },
    ],
  },
];

export const findReportLayoutItem = (
  searchId: string
): IReportSectionItem | undefined => {
  for (const section of ReportLayoutSections) {
    const foundItem = section.items.find((item) => item.id === searchId);
    if (foundItem) return foundItem;
  }
  return undefined;
};
